import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Training Implications by Department',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Training Implications',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Change Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'advancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'advancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'advancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'alumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'alumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'annualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'campaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'corporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'developmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'development',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'donorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'foundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'majorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'planningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'principalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'prospectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    majorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    development: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    annualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    planningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    principalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    alumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    alumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    advancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    campaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    corporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    foundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    prospectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    advancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    developmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    donorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    advancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
